// to accomodate V2 -> V1 parity for claim times, we store in UTC format but the timezone is assumed EST
// get current time in UTC, remove 4 or 5 hours to get EST time, then convert to ISO string and drop the "Z"
const { DateTime } = require("luxon");
export const getEstTimeAsUtc = () => {
  const estTime = DateTime.now().setZone("America/New_York");
  const estTimeISO = estTime.toFormat("yyyy-MM-dd'T'HH:mm:ss.SSS");
  return estTimeISO;
};
